import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import 'vuetify/lib/styles/settings/_index.sass'; // Import Vuetify styles
// import 'vuetify/lib/styles/generic/_index.scss';
import 'vuetify/lib/styles/elements/_index.sass';
import 'vuetify/lib/styles/utilities/_index.sass';
// import '@mdi/font/css/materialdesignicons.css'; // Optional: Material Design Icons

export default createVuetify({
  components,
  directives,
  // Optional: Configure theme, icons, etc.
  theme: {
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
});
